import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=1ad374be&scoped=true"
import script from "./OAuth.vue?vue&type=script&lang=ts"
export * from "./OAuth.vue?vue&type=script&lang=ts"
import style0 from "./OAuth.vue?vue&type=style&index=0&id=1ad374be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad374be",
  null
  
)

export default component.exports